/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
import React from "react";
import { Props, LocalesArguments } from "./types";
const EMPTY_VALUE = "-";

const Currency: React.FC<Props> = ({
  isDecimal = false,
  value = 0,
  isSymbol = false,
}) => {
  const numericValue = parseNumber(value);
  const formatValue =
    numericValue !== null
      ? getValue(numericValue, isSymbol, isDecimal)
      : EMPTY_VALUE;
  const title = numericValue !== null ? numericValue.toString() : EMPTY_VALUE;

  return (
    <span className="currency" title={title}>
      {formatValue}
    </span>
  );
};

/**
 * Converts various input types into a valid number or returns null if invalid.
 */
function parseNumber(value: unknown): number | null {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    Number.isNaN(value)
  ) {
    return null;
  }

  const num = typeof value === "number" ? value : parseFloat(value as string);
  return Number.isNaN(num) ? null : num;
}

/**
 * Formats a number into a currency or regular numeric format.
 */
function getValue(
  value: number,
  isSymbol: boolean,
  isDecimal: boolean
): string {
  const options: LocalesArguments = {
    minimumFractionDigits: isDecimal ? 2 : 0,
    maximumFractionDigits: 2,
    ...(isSymbol ? { style: "currency", currency: "EUR" } : {}),
  };

  return value.toLocaleString("en-US", options);
}

export default Currency;
